import { fetchData } from "@/lib/api/fetchData";

export const insertAction = async (action) => {
  try {
    const res = await fetchData("/rules/actions", {
      method: "POST",
      body: action,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to insert action");
  }
};

export const updateAction = async (action) => {
  try {
    const res = await fetchData(`/rules/actions/${action.id}`, {
      method: "PATCH",
      body: action,
      contentType: "application/merge-patch+json",
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to update action");
  }
};
